/* eslint no-unused-vars: 0 */
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import * as Actions from '../../../actions/actions';

import StatsWidget from './StatsWidget';
import ContactForm from './ContactForm';

import { DefaultServices } from '../../../constants/DefaultServices';

/* eslint max-len: 0 */
export class MatchPage extends Component {
    constructor() {
        super();
        this.state = { isModalOpen: false };
    }

    closeModal() {
        this.setState({ isModalOpen: false });
    }

    handleContactSubmit() {
        if (!this.props.canSubmit) {
            return;
        }

        browserHistory.push('message');
    }

    renderMatchingContent() {
        return (
            <div className="app__match-page__content">
                <div className="app__match-page__left">
                    <div className="match-page__widget">
                        <StatsWidget showButton={ false } isVertical={ true }/>
                    </div>
                </div>
                <div className="app__match-page__right">
                    <div className="match-page__form">
                        <ContactForm handler={ this.handleContactSubmit.bind(this) }/>
                    </div>
                </div>
            </div>
        );
    }

    renderBanner() {
        return (
            <div className="app__match-page__full-image match-page__image">
                <div className="opacity-layer">
                    <div className="app__match-page__title">
                        <h1 className="vouchedfor-brand">
                            Enter your details and a highly rated mortgage adviser will be in touch
                        </h1>
                        <div className="app__match-page__subtitle">
                            The first call will just be to explain how they can help; there is no commitment!
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="app__landing-page__section--full app__match-page__container">

                { this.renderBanner() }

                { this.renderMatchingContent() }

                <div className="app__match-page__subtitle">
                    <p>Prefer to speak to us? Freephone 0330 038 8543</p>
                </div>

            </div>
        );
    }
}

MatchPage.propTypes = {
    actions: React.PropTypes.object,

    person: React.PropTypes.object,

    invalidSubmit: React.PropTypes.bool,
    canSubmit: React.PropTypes.bool,
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

function mapStateToProps(state) {
    return {
        person: state.reducer.get('person'),

        invalidSubmit: state.navigation.get('invalidSubmit'),
        canSubmit: state.navigation.get('canSubmit'),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MatchPage);



// WEBPACK FOOTER //
// ./src/components/steps/matching/MatchPage.jsx